var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"placeholder":"Sök","prepend-inner-icon":"search","rounded":"","filled":"","background-color":"white","dense":"","hide-details":""}})}
var staticRenderFns = []

export { render, staticRenderFns }